const SPECIAL_WORDS: Record<string, string> = {
  iphone: 'iPhone',
  ipad: 'iPad',
  ios: 'iOS',
  macbook: 'MacBook',
  air: 'Air',
  pro: 'Pro',
  max: 'Max',
  plus: 'Plus',
  mini: 'Mini',
  ultra: 'Ultra',
  se: 'SE',
  gb: 'GB',
  tb: 'TB',
  mb: 'MB',
}

function formatStorageToken(word: string): string | null {
  const m = word.match(/^(\d+)(gb|tb|mb)$/i)
  if (!m) return null
  const unit = SPECIAL_WORDS[m[2].toLowerCase()] ?? m[2].toUpperCase()
  return `${m[1]} ${unit}`
}

function formatWord(word: string): string {
  const storage = formatStorageToken(word)
  if (storage) return storage
  const lower = word.toLowerCase()
  if (SPECIAL_WORDS[lower]) return SPECIAL_WORDS[lower]
  if (/^\d+$/.test(word)) return word
  return lower.charAt(0).toUpperCase() + lower.slice(1)
}

function formatModelPhrase(model: string): string {
  return model
    .split(/\s+/)
    .filter(Boolean)
    .map(formatWord)
    .join(' ')
}

function formatBrand(brand: string): string {
  const trimmed = brand.trim()
  if (!trimmed) return ''
  const lower = trimmed.toLowerCase()
  if (lower === 'apple') return 'Apple'
  if (lower === 'samsung') return 'Samsung'
  if (lower === 'google') return 'Google'
  if (lower === 'xiaomi') return 'Xiaomi'
  if (lower === 'oneplus') return 'OnePlus'
  return formatWord(trimmed)
}

function isUnknownDeviceLabel(value: string | undefined): boolean {
  return !value?.trim() || value.trim().toLowerCase() === 'unknown'
}

/** Human-readable device title for Verify report (no duplicated brand, title case). */
export function formatVerifyDeviceTitle(
  brand: string | null | undefined,
  model: string | null | undefined,
): string | null {
  const bRaw = isUnknownDeviceLabel(brand ?? undefined) ? '' : brand!.trim()
  let mRaw = isUnknownDeviceLabel(model ?? undefined) ? '' : model!.trim()
  if (!bRaw && !mRaw) return null

  const brandLower = bRaw.toLowerCase()
  if (bRaw && mRaw.toLowerCase().startsWith(brandLower)) {
    mRaw = mRaw.slice(bRaw.length).replace(/^[\s·\-–—]+/, '').trim()
  }

  const words = mRaw.split(/\s+/).filter(Boolean)
  while (words.length && words[0].toLowerCase() === brandLower) {
    words.shift()
  }
  mRaw = words.join(' ')

  const brandPart = formatBrand(bRaw)
  const modelPart = formatModelPhrase(mRaw)

  if (brandPart && modelPart) return `${brandPart} ${modelPart}`
  return brandPart || modelPart || null
}
